export class SchdulerOrder {
    id: number;
    start_date: Date;
    end_date: Date;
    text: string;
    driver_id: number;
    statusCode: string;
    tooltipText: string;
    color: string;
    blockText: string;
  }



// WEBPACK FOOTER //
// ./src/app/core/scheduler-order.ts